var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audit-list-item"},[_vm._m(0),_c('div',[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.user)+" ")]),_vm._v(" "+_vm._s(_vm.action)+" ")]),_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm._f("parseDate")(_vm.date))+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar"},[_c('i',{staticClass:"fas fa-user-circle"})])
}]

export { render, staticRenderFns }